import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { class: "w3-bar-item w3-button w3-large" }, "Close ×", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("in ports")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Virtual ports")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Monitor")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("JS/Net routing")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Presets")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("User Controls")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Easyconfig")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_12 = {
  key: 0,
  id: "nav",
  class: "w3-teal w3-bar w3-container w3-row",
  style: {"position":"fixed"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "w3-button" }, "☰", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  class: "w3-col",
  style: {"width":"80%"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "w3-right w3-button",
  onclick: "document.getElementById('id01').style.display='block'"
}, "Monitor", -1)
const _hoisted_17 = { id: "main" }
const _hoisted_18 = {
  key: 1,
  id: "id01",
  class: "w3-modal",
  style: {"padding-top":"0px"}
}
const _hoisted_19 = { class: "w3-modal-content" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  onclick: "document.getElementById('id01').style.display='none'",
  class: "w3-button w3-display-topright"
}, "×", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MonitorComponent = _resolveComponent("MonitorComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "w3-sidebar w3-bar-block w3-card w3-animate-left",
      style: {"display":"none"},
      id: "mySidebar",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarClose()))
    }, [
      _hoisted_2,
      _createVNode(_component_router_link, {
        class: "w3-bar-item w3-button",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "w3-bar-item w3-button",
            to: "/midiinlist"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "w3-bar-item w3-button",
            to: "/virtualports"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: "w3-bar-item w3-button",
            to: "/monitor"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            class: "w3-bar-item w3-button",
            to: "/jsclient"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            class: "w3-bar-item w3-button",
            to: "/presets"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 5,
            class: "w3-bar-item w3-button",
            to: "/usercontrols"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 6,
            class: "w3-bar-item w3-button",
            to: "/easyconfig"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        class: "w3-bar-item w3-button",
        to: "/about"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("a", {
            key: 7,
            class: "w3-bar-item w3-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shutdownQuit && _ctx.shutdownQuit(...args)))
          }, "Quit"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "w3-col",
            style: {"width":"20%"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sidebarOpen()))
          }, _hoisted_14),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", {
              class: "w3-right w3-button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyChanges && _ctx.applyChanges(...args)))
            }, "Apply " + _toDisplayString(_ctx.defaultPresetName), 1),
            _hoisted_16
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_MonitorComponent, {
              ref: "monitor",
              showHeader: false
            }, null, 512)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}